<template>
  <div class="bread">
    <el-breadcrumb
      separator-class="el-icon-arrow-right"
      v-for="item in list"
      :key="item.text"
    >
      <el-breadcrumb-item :to="{ path: item.path }" v-if="!item.isActive">{{
        item.text
      }}</el-breadcrumb-item>
      <el-breadcrumb-item v-else>{{ item.text }}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>
<script>
export default {
  props: {
    list: {
      Array: true,
      required: true,
    },
  },
};
</script>
<style lang="sass" scoped>
.bread
  padding: 0 2%
</style>